module.exports = __webpack_public_path__ + "img/infralogo.1dbd89f2.png";